
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.532 17.426a1.81 1.81 0 00-1.81-1.683h-6.108v-1.842c0-3.604-2.95-6.54-6.57-6.54h-3.069c-3.62 0-6.569 2.936-6.569 6.54v1.842h-6.11c-.949 0-1.749.737-1.809 1.683l-2.23 32.983c-.03.498.14.996.49 1.354.34.368.83.568 1.33.568h32.875c.5 0 .98-.21 1.33-.578.34-.368.52-.856.48-1.354l-2.23-32.973zM23.396 13.9c0-2.508 2.05-4.55 4.569-4.55h3.07c2.52 0 4.569 2.041 4.569 4.55v1.842H23.396v-1.842zM13.257 50.35l2.2-32.615h5.939v1.912c-1 .398-1.7 1.364-1.7 2.489a2.695 2.695 0 002.7 2.688c1.49 0 2.7-1.205 2.7-2.688 0-1.135-.71-2.1-1.7-2.49v-1.91h12.208v1.91c-1 .4-1.7 1.365-1.7 2.49a2.695 2.695 0 002.7 2.688c1.49 0 2.7-1.205 2.7-2.688 0-1.135-.7-2.1-1.7-2.49v-1.91h5.939l2.2 32.614H13.256z"}})])
          )
        }
      }
    